<template>
  <select-lang class="account-language-select" @change:language="change_language" />
</template>

<script>
  import { mapActions } from 'vuex';
  import SelectLang from '@shared/components/select-lang';
  export default {
    components: { SelectLang },
    methods: {
      ...mapActions('core/auth', ['setBackendLocale']),

      change_language: function (name) {
        this.setBackendLocale(name);
      }
    }
  };
</script>
<style lang="scss">
  .account-language-select {
    .language-select {
      &__title {
        &:hover {
          background-color: #586e82;
        }
      }
    }
  }
</style>
